var _defs, _path, _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScanIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    zoomAndPan: "magnify",
    viewBox: "0 0 45 44.999999",
    height: 60,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "4ed55fc4c4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.039062 26 L 17 26 L 17 39 L 6.039062 39 Z M 6.039062 26 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a8b8d52264"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 26 6.039062 L 39 6.039062 L 39 19 L 26 19 Z M 26 6.039062 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f2a21008d9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.039062 6.039062 L 19 6.039062 L 19 19 L 6.039062 19 Z M 6.039062 6.039062 ",
    clipRule: "nonzero"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f26836",
    d: "M 37.859375 26.886719 C 37.25 26.886719 36.761719 27.375 36.761719 27.984375 L 36.761719 36.761719 L 29.148438 36.761719 C 28.542969 36.761719 28.050781 37.25 28.050781 37.859375 C 28.050781 38.464844 28.542969 38.957031 29.148438 38.957031 L 37.859375 38.957031 C 38.464844 38.957031 38.957031 38.464844 38.957031 37.859375 L 38.957031 27.984375 C 38.957031 27.375 38.464844 26.886719 37.859375 26.886719 Z M 37.859375 26.886719 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4ed55fc4c4)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f26836",
    d: "M 7.136719 38.957031 L 15.84375 38.957031 C 16.449219 38.957031 16.941406 38.464844 16.941406 37.859375 C 16.941406 37.25 16.449219 36.761719 15.84375 36.761719 L 8.230469 36.761719 L 8.230469 27.984375 C 8.230469 27.375 7.742188 26.886719 7.136719 26.886719 C 6.527344 26.886719 6.039062 27.375 6.039062 27.984375 L 6.039062 37.859375 C 6.039062 38.464844 6.527344 38.957031 7.136719 38.957031 Z M 7.136719 38.957031 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a8b8d52264)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f26836",
    d: "M 37.859375 6.039062 L 27.984375 6.039062 C 27.375 6.039062 26.886719 6.527344 26.886719 7.136719 C 26.886719 7.742188 27.375 8.230469 27.984375 8.230469 L 36.761719 8.230469 L 36.761719 17.011719 C 36.761719 17.617188 37.25 18.109375 37.859375 18.109375 C 38.464844 18.109375 38.957031 17.617188 38.957031 17.011719 L 38.957031 7.136719 C 38.957031 6.527344 38.464844 6.039062 37.859375 6.039062 Z M 37.859375 6.039062 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f2a21008d9)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f26836",
    d: "M 7.136719 18.109375 C 7.742188 18.109375 8.230469 17.617188 8.230469 17.011719 L 8.230469 8.230469 L 17.011719 8.230469 C 17.617188 8.230469 18.105469 7.742188 18.105469 7.136719 C 18.105469 6.527344 17.617188 6.039062 17.011719 6.039062 L 7.136719 6.039062 C 6.527344 6.039062 6.039062 6.527344 6.039062 7.136719 L 6.039062 17.011719 C 6.039062 17.617188 6.527344 18.109375 7.136719 18.109375 Z M 7.136719 18.109375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanIcon);
export default __webpack_public_path__ + "static/media/Scan Icon.3ceb0fa47a6c9901b163e96c687f2134.svg";
export { ForwardRef as ReactComponent };